import { environment } from '../../environments/environment';

export class SettingsService {
  static apiBaseUrl = environment.api_url;

  static api = {
    autoCompleteGetByKeywordUrl: SettingsService.apiBaseUrl + '/Autocomplete/Get',
    autocompleteGetByKeywordAndLocationUrl: SettingsService.apiBaseUrl + '/Autocomplete/GetByLocation/',
    autocompleteGetByKeywordAndGeolocationUrl: SettingsService.apiBaseUrl + '/Autocomplete/GetByGeolocation/',
    autocompleteLocationUrl: SettingsService.apiBaseUrl + '/AutocompleteLocation/',
    personProfileUrl: SettingsService.apiBaseUrl + '/People/GetById',
    placeProfileUrl: SettingsService.apiBaseUrl + '/Places/GetById',

    searchPlacesByNameProfileUrl: SettingsService.apiBaseUrl + '/Places/GetByName',
    searchPlacesByNameAndLocationProfileUrl: SettingsService.apiBaseUrl + '/Places/GetByNameAndLocation',
    searchPlacesByServiceProfileUrl: SettingsService.apiBaseUrl + '/Places/GetByService',
    searchPlacesByServiceAndLocationProfileUrl: SettingsService.apiBaseUrl + '/Places/GetByServiceAndLocation',
    searchPlacesByNameAndGeolocationProfileUrl: SettingsService.apiBaseUrl + '/Places/GetByNameAndGeolocation',
    searchPlacesByServiceAndGeolocationProfileUrl: SettingsService.apiBaseUrl + '/Places/GetByServiceAndGeolocation',

    searchPeopleByNameProfileUrl: SettingsService.apiBaseUrl + '/People/GetByName',
    searchPeopleByNameAndLocationProfileUrl: SettingsService.apiBaseUrl + '/People/GetByNameAndLocation',
    searchPeopleByServiceProfileUrl: SettingsService.apiBaseUrl + '/People/GetByService',
    searchPeopleByServiceAndLocationProfileUrl: SettingsService.apiBaseUrl + '/People/GetByServiceAndLocation',
    searchPeopleByNameAndGeolocationProfileUrl: SettingsService.apiBaseUrl + '/People/GetByNameAndGeolocation',
    searchPeopleByServiceAndGeolocationProfileUrl: SettingsService.apiBaseUrl + '/People/GetByServiceAndGeolocation',

    searchLocationsByNameUrl: SettingsService.apiBaseUrl + '/Locations/GetByName',
    searchLocationsByNameAndLocationUrl: SettingsService.apiBaseUrl + '/Locations/GetByNameAndLocation',
    searchLocationsByNameAndGeolocationUrl: SettingsService.apiBaseUrl + '/Locations/GetByNameAndGeolocation',
    searchLocationsByServiceUrl: SettingsService.apiBaseUrl + '/Locations/GetByService',
    searchLocationsByServiceAndLocationUrl: SettingsService.apiBaseUrl + '/Locations/GetByServiceAndLocation',
    searchLocationsByServiceAndGeolocationUrl: SettingsService.apiBaseUrl + '/Locations/GetByServiceAndGeolocation',

    totalsByNameUrl: SettingsService.apiBaseUrl + '/Totals/GetByName',
    totalsByNameAndLocationUrl: SettingsService.apiBaseUrl + '/Totals/GetByNameAndLocation',
    totalsByNameAndGeolocationUrl: SettingsService.apiBaseUrl + '/Totals/GetByNameAndGeolocation',
    totalsByServiceUrl: SettingsService.apiBaseUrl + '/Totals/GetByService',
    totalsByServiceAndLocationUrl: SettingsService.apiBaseUrl + '/Totals/GetByServiceAndLocation',
    totalsByServiceAndGeolocationUrl: SettingsService.apiBaseUrl + '/Totals/GetByServiceAndGeolocation',

    reportIncorrectDetailsUrl: SettingsService.apiBaseUrl + '/report',
  };

  static values = {
    defaultPageTitle: 'Healthcare finder - Southern Cross Health Society',
    searchResultsTitle: 'Search results',
    noResultsText: "Oops. Looks like we haven't found anything for you.",
    keywordsInputPlaceholder: 'Start typing a healthcare provider/service/facility',
    locationInputPlaceholder: 'Enter your location',
    /* eslint-disable no-useless-escape */
    consultIconTitle: `An Affiliated Provider who performs specialist
consultations. Please check their profile to ensure they
offer the specific healthcare service or consultation
you need. If you\'re unable to find an Affiliated
Provider near you that offers the healthcare service
you need, please contact us. This is important for
Affiliated Provider only healthcare services.`,
    virtualConsultationTitle: `An Affiliated Provider who performs specialist
initial and follow-up consultations via telehealth.
A telehealth consultation is the use of video or phone
to deliver healthcare consultations when Southern Cross
patients and Affiliated Providers are in different
physical locations and when no physical examination is
required. Please ensure that you have a good internet
connection and are in a quiet, private place. The
Affiliated Provider will direct you further on how to
conduct the telehealth consultation.`,
    /* eslint-enable no-useless-escape */
  };

  static uiMessageClass = {
    error: 'error',
  };

  static uiMessage = {
    genericError: {
      text: 'Something went wrong. Please try to reload the page or contact us.',
      class: SettingsService.uiMessageClass.error,
    },
  };

  static autoCompleteValues = {
    viewAllPeopleText: 'Show all',
    viewAllPlacesText: 'Show all',
    viewAllServiceCategoriesText: 'Show all',
    viewAllServicesText: 'Show all',
    viewAllSpecialtiesText: 'Show all',
    seeAllResultsText: 'See all results',
    noResultsText: 'No results found',
    useMyLocationText: 'Use my location',
    lookingForMyLocationText: 'Waiting for location...',
    foundMyLocationText: 'Using your location',
    failedMyLocation: 'Location lookup failed',
  };

  static searchResultsType = {
    all: 'all',
    people: 'people',
    places: 'places',
    serviceCategory: 'servicecategory',
    serviceCategories: 'servicecategories',
    services: 'servicedescriptions',
    service: 'services',
    specialties: 'specialties',
    specialty: 'specialty',
  };
}
